<button *ngIf="options" [class.active]="options.active" [class.fullWidth]="options.fullWidth"
        [class.mat-raised-button]="options.raised"
        [color]="options.buttonColor" [disabled]="disabled || options.disabled" class="m--margin-5 fixing-size-button"
        mat-raised-button>
    <span><ng-content></ng-content></span>
    <mat-spinner *ngIf="options.active" [color]="options.spinnerColor" [diameter]="options.spinnerSize"
                 [mode]="options.mode"
                 [value]="options.value" class="spinner"></mat-spinner>
</button>
